import { tv } from 'tailwind-variants';

const headingStyles = tv({
  slots: {
    base: `
    iris:font-(family-name:--base-type-font-heading)
    iris:font-(--sem-type-weight-heading)!
    iris:tracking-(--sem-type-tracking-heading)
    iris:text-(--comp-color-content-type-heading)
  `,
    leading: "iris:leading-(--sem-type-leading-heading)"
  },
  variants: {
    size: {
      xxl: "",
      xl: "",
      lg: "",
      md: ""
    },
    inverse: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
  // Heading styles for different sizes
  {
    size: "md",
    className: `
        iris:text-(length:--sem-type-size-heading-md-mobile)
        iris:md:text-(length:--sem-type-size-heading-md-desktop)
      `
  }, {
    size: "lg",
    className: `
        iris:text-(length:--sem-type-size-heading-lg-mobile)
        iris:md:text-(length:--sem-type-size-heading-lg-desktop)
      `
  }, {
    size: "xl",
    className: `
        iris:text-(length:--sem-type-size-heading-xl-mobile)
        iris:md:text-(length:--sem-type-size-heading-xl-desktop)
      `
  }, {
    size: "xxl",
    className: `
        iris:text-(length:--sem-type-size-heading-xxl-mobile)
        iris:md:text-(length:--sem-type-size-heading-xxl-desktop)
      `
  },
  // Inverse styles
  {
    inverse: true,
    className: "iris:text-(--comp-color-content-type-heading-inverse)"
  }],
  // Default variants for the headingStyles
  defaultVariants: {
    size: "md",
    inverse: false
  }
});

export { headingStyles as default };
